module.exports = __webpack_public_path__ + "static/01-thumb-f99a4f14963c1f52dd0b9eff2175e73f.jpg";